import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getAnalyticsConsent,
  initTelemetry,
  setAnalyticsConsent,
  trackPageView,
} from "../lib/telemetry";

export default function AnalyticsConsent() {
  const [choice, setChoice] = useState(null);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    setChoice(getAnalyticsConsent());
    const openSettings = () => setSettingsOpen(true);
    window.addEventListener("open-analytics-settings", openSettings);
    return () => window.removeEventListener("open-analytics-settings", openSettings);
  }, []);

  function choose(granted) {
    setAnalyticsConsent(granted);
    setChoice(granted);
    setSettingsOpen(false);

    if (granted) {
      initTelemetry();
      trackPageView(window.location.pathname, window.location.search);
    }
  }

  if (choice !== null && !settingsOpen) {
    return null;
  }

  return (
    <aside className="consent-banner" aria-label="Analytics preferences" aria-live="polite">
      <div>
        <p className="consent-banner__title">Optional analytics</p>
        <p>
          This site can use privacy-conscious Mixpanel analytics to understand which pages readers find useful. Session recording and automatic interaction capture are disabled. Nothing loads unless you allow it. <Link to="/privacy">Privacy details</Link>
        </p>
      </div>
      <div className="consent-banner__actions">
        <button type="button" className="button button--consent-secondary" onClick={() => choose(false)}>
          Essential only
        </button>
        <button type="button" className="button button--consent-primary" onClick={() => choose(true)}>
          Allow analytics
        </button>
      </div>
    </aside>
  );
}
